import { useNavigate } from "react-router-dom";

function useDetailsAction(): any {

  const navigate = useNavigate();

  const detailsFunction = (id: any) => {
      navigate(`/panel/league/${id}/categories`);
  };

  /** END EDIT FORM ACTION */

  return {
    detailsFunction,
  };
}

export default useDetailsAction;
